import React from 'react';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Login from '../Login/Login'
import Footer from '../GeneralComponents/Footer'
import Services from '../Services';
import UserProfile from '../UserProfile';
import ProjectsDetails from '../Projects/ProjectsDetails';
import Map from '../Projects/Map/Map';
import Signature from '../Projects/Signature';
import Header from '../GeneralComponents/Header';
import Leave from '../Leaves/Leave';
import Projects from '../Projects/Projects';
import ProjectReview from '../Projects/ProjectReview';
import ScanQR from '../Projects/ScanQR/ScanQR';
import UserRate from 'pages/userRate/UserRate';

const ProjectRoutes = () => {
  return (
    <>
      <Router>
        {/* in Header component we check current url and if its equal to login page,
        we hide header in login page */}
        <Header />
        <Routes>
          <Route index element={<Services />} />
          <Route path="/login" element={<Login />} />
          <Route path="/services" element={<Services />} />
          <Route path="/leave" element={<Leave />} />
          <Route path="/profile" element={<UserProfile />} />
          <Route path="/projects" element={<Projects />} />
          <Route path="/projects/projectsDetails" element={<ProjectsDetails />} />
          <Route path="/projects/map" element={<Map />} />
          <Route path="/projects/signature" element={<Signature />} />
          <Route path="/projects/project-review" element={<ProjectReview />} />
          <Route path="/projects/ScanQR" element={<ScanQR />} />
          <Route path="/user-rate" element={<UserRate />} />
        </Routes>
        {/* in Footer component we check current url and if its equal to login page,
        we hide header in login page */}
        <Footer />
      </Router>
    </>



  )
}

export default ProjectRoutes
